import { render, staticRenderFns } from "./bankSearchModel.vue?vue&type=template&id=48fd4ad3"
import script from "./bankSearchModel.vue?vue&type=script&lang=js"
export * from "./bankSearchModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports